/* -----------------------------------------------------------------------------
 * Security SM Actions
 *
 * @description - Actions of Security SM. Check ./README.md for more info.
 * -----------------------------------------------------------------------------
 */

import { http } from '@/utils/http'

export default {

  /**
   * Send message
   * @description Sends message to parent frame, if it exists
   * @param {Number} h - app height value
   * @param {Boolean} l - get location.href from parent or not
   * @param {Boolean} t - get config from parent or not
   * @param {String} e - app activity event name
   * @param {Function} callback - Given callback function
   */
  sendMessage ({ state, commit }, { h = 0, l = false, t = false, e = '', callback = null }) {
    if (callback) commit('SET_MESSAGE_CALLBACK', callback)
    if (e.length > 0) {
      if (state.events.indexOf(e) < 0) {
        commit('ADD_EVENT', e)
      } else {
        e = ''
      }
    }
    window.parent.postMessage(JSON.stringify({ h, l, t, e }), '*')
  },

  /**
   * Receive message
   * @description Receives messages from parent frame
   * @param {Object} state - Security SM state
   * @param {Object} commit - Security SM mutations
   * @param {Object} event - Received event
   */
  receiveMessage ({ state, commit }, event) {
    if (event.source !== window.parent) return // listen only parent messages
    const { l, t } = JSON.parse(event.data)
    if (l) commit('SET_PARENT_LOCATION', l)
    if (t) commit('SET_APP_CONFIG', t, { root: true })
    if (state.callback) state.callback()
  },

  /**
   * App verify
   * @description Sends given data to the backend for verification purpose
   * @param {Object} rootState - Root state
   * @param {Object} getters- Security SM getters
   * @param {Object} commit - Security SM mutations
   * @returns
   */
  async appVerify ({ state, rootState, getters, commit }) {
    try {
      const { status, errors } = (await http({
        url: 'controlcenter/verify',
        method: 'post',
        data: {
          token: rootState.config.token,
          utm_tags: getters.getQueryParams,
          source_host_name: state.location.hostname || 'unknown'
        },
        noToken: true
      })).data
      if (status) commit('SET_TOKEN', rootState.config.token)
      return { status, errors }
    } catch (e) {
      return {
        status: false,
        errors: { global: [`Ошибка #${e.response.status}`] }
      }
    }
  }

}
